export default {
  viewedEducationData: {},
  notificationData: {}
};
